import { SubscriptionReq, UploadImageResp } from "@garther/interfaces";
import { useMutation } from "@tanstack/react-query";

import { useApiClients } from "./context";

export function useUploadImageMutation(
  options: {
    onSuccess?: (result: UploadImageResp) => void;
    onError?: (error: unknown) => void;
  } = {}
) {
  const { publicApiClient } = useApiClients();
  return useMutation({
    mutationFn: (file: File) => {
      if (!publicApiClient) throw new Error("publicApiClient is not available");
      return publicApiClient.uploadImage(file);
    },
    onSuccess: (result) => {
      options.onSuccess?.(result);
    },
    onError: (error) => options.onError?.(error)
  });
}

export function useSubscribeToNewsletterMutation(
  options: { onSuccess?: () => void; onError?: (error: unknown) => void } = {}
) {
  const { publicApiClient } = useApiClients();
  return useMutation({
    mutationFn: (data: SubscriptionReq) => {
      if (!publicApiClient) throw new Error("publicApiClient is not available");
      return publicApiClient.subscribeToNewsletter(data);
    },
    onSuccess: () => options.onSuccess?.(),
    onError: (error) => options.onError?.(error)
  });
}
